export default {

    getLoginURL(event) {
        return event ? '/event/validateUser' : '/admin/validateUser';
    }

}